var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeypointsToolSmart = function SvgKeypointsToolSmart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.5C17.9624 3.5 15.5 5.96243 15.5 9C15.5 12.0376 17.9624 14.5 21 14.5C24.0376 14.5 26.5 12.0376 26.5 9C26.5 5.96243 24.0376 3.5 21 3.5ZM3.5 16C3.5 12.9624 5.96243 10.5 9 10.5C12.0376 10.5 14.5 12.9624 14.5 16C14.5 19.0376 12.0376 21.5 9 21.5C5.96243 21.5 3.5 19.0376 3.5 16ZM15.5 23C15.5 19.9624 17.9624 17.5 21 17.5C24.0376 17.5 26.5 19.9624 26.5 23C26.5 26.0376 24.0376 28.5 21 28.5C17.9624 28.5 15.5 26.0376 15.5 23Z",
    fill: "#7F64FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2756 20.6208C20.3042 20.4777 20.3185 20.4062 20.3257 20.3807C20.5165 19.6989 21.483 19.6989 21.6739 20.3807C21.681 20.4062 21.6953 20.4777 21.7239 20.6208C21.7377 20.6898 21.7446 20.7243 21.752 20.7558C21.9252 21.4964 22.5034 22.0747 23.244 22.2478C23.2755 22.2552 23.31 22.2621 23.3791 22.2759C23.5221 22.3045 23.5936 22.3188 23.6191 22.326C24.3009 22.5168 24.3009 23.4833 23.6191 23.6742C23.5936 23.6813 23.5221 23.6956 23.3791 23.7242C23.31 23.738 23.2755 23.7449 23.244 23.7523C22.5034 23.9255 21.9252 24.5037 21.752 25.2443C21.7446 25.2758 21.7377 25.3103 21.7239 25.3794C21.6953 25.5224 21.681 25.594 21.6739 25.6194C21.483 26.3012 20.5165 26.3012 20.3257 25.6194C20.3185 25.594 20.3042 25.5224 20.2756 25.3794C20.2618 25.3103 20.2549 25.2758 20.2475 25.2443C20.0744 24.5037 19.4961 23.9255 18.7555 23.7523C18.724 23.7449 18.6895 23.738 18.6204 23.7242C18.4774 23.6956 18.4059 23.6813 18.3804 23.6742C17.6986 23.4833 17.6986 22.5168 18.3804 22.326C18.4059 22.3188 18.4774 22.3045 18.6204 22.2759C18.6895 22.2621 18.724 22.2552 18.7555 22.2478C19.4961 22.0747 20.0744 21.4964 20.2475 20.7558C20.2549 20.7243 20.2618 20.6898 20.2756 20.6208Z",
    fill: "#5531FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2756 6.62075C20.3042 6.4777 20.3185 6.40617 20.3257 6.38071C20.5165 5.69893 21.483 5.69893 21.6739 6.38071C21.681 6.40617 21.6953 6.4777 21.7239 6.62075C21.7377 6.6898 21.7446 6.72432 21.752 6.75579C21.9252 7.49639 22.5034 8.07466 23.244 8.24785C23.2755 8.25521 23.31 8.26211 23.3791 8.27592C23.5221 8.30453 23.5936 8.31884 23.6191 8.32596C24.3009 8.51678 24.3009 9.48335 23.6191 9.67416C23.5936 9.68128 23.5221 9.69559 23.3791 9.7242C23.31 9.73801 23.2755 9.74491 23.244 9.75227C22.5034 9.92546 21.9252 10.5037 21.752 11.2443C21.7446 11.2758 21.7377 11.3103 21.7239 11.3794C21.6953 11.5224 21.681 11.594 21.6739 11.6194C21.483 12.3012 20.5165 12.3012 20.3257 11.6194C20.3185 11.594 20.3042 11.5224 20.2756 11.3794C20.2618 11.3103 20.2549 11.2758 20.2475 11.2443C20.0744 10.5037 19.4961 9.92546 18.7555 9.75227C18.724 9.74491 18.6895 9.73801 18.6204 9.7242C18.4774 9.69559 18.4059 9.68128 18.3804 9.67416C17.6986 9.48335 17.6986 8.51678 18.3804 8.32596C18.4059 8.31884 18.4774 8.30453 18.6204 8.27592C18.6895 8.26211 18.724 8.25521 18.7555 8.24785C19.4961 8.07466 20.0744 7.49639 20.2475 6.75579C20.2549 6.72432 20.2618 6.6898 20.2756 6.62075Z",
    fill: "#5531FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27562 13.6208C8.30423 13.4777 8.31853 13.4062 8.32566 13.3807C8.51647 12.6989 9.48304 12.6989 9.67385 13.3807C9.68098 13.4062 9.69528 13.4777 9.72389 13.6208C9.7377 13.6898 9.74461 13.7243 9.75197 13.7558C9.92515 14.4964 10.5034 15.0747 11.244 15.2478C11.2755 15.2552 11.31 15.2621 11.3791 15.2759C11.5221 15.3045 11.5936 15.3188 11.6191 15.326C12.3009 15.5168 12.3009 16.4833 11.6191 16.6742C11.5936 16.6813 11.5221 16.6956 11.3791 16.7242C11.31 16.738 11.2755 16.7449 11.244 16.7523C10.5034 16.9255 9.92515 17.5037 9.75197 18.2443C9.74461 18.2758 9.7377 18.3103 9.72389 18.3794C9.69528 18.5224 9.68098 18.594 9.67385 18.6194C9.48304 19.3012 8.51647 19.3012 8.32566 18.6194C8.31853 18.594 8.30423 18.5224 8.27562 18.3794C8.26181 18.3103 8.2549 18.2758 8.24754 18.2443C8.07436 17.5037 7.49609 16.9255 6.75549 16.7523C6.72401 16.7449 6.68949 16.738 6.62045 16.7242C6.47739 16.6956 6.40587 16.6813 6.38041 16.6742C5.69862 16.4833 5.69862 15.5168 6.38041 15.326C6.40587 15.3188 6.47739 15.3045 6.62045 15.2759C6.68949 15.2621 6.72401 15.2552 6.75549 15.2478C7.49609 15.0747 8.07436 14.4964 8.24754 13.7558C8.2549 13.7243 8.26181 13.6898 8.27562 13.6208Z",
    fill: "#5531FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 14.8691,
    y: 17.8694,
    width: 12.2614,
    height: 12.2614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 14.8691,
    y: 3.86938,
    width: 12.2614,
    height: 12.2614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 2.86914,
    y: 10.8694,
    width: 12.2614,
    height: 12.2614,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeypointsToolSmart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "keypoints-tool-smart.d07d3429f89cc9b039deccb94c5f0883.svg";